// extracted by mini-css-extract-plugin
export default {"PurchasedQuantity":"PurchasedQuantity-styles__PurchasedQuantity__dZBpn","PurchasedQuantity__Label":"PurchasedQuantity-styles__PurchasedQuantity__Label__BH8gW"};